import React from 'react';
function Header() {
  return (
    <div className="header">
        <h1 className="title">Marcelino Matias</h1>
    </div>
  );
}

export default Header;
